import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	frameSpotlightLabel: {
		id: 'company-hub.carousel-extension.frame-spotlight.label',
		defaultMessage: 'frame {positionInSet} of {setSize}',
		description: 'Accessibility label text that is used for each spotlight in the carousel',
	},
});
